export enum Direction {
  IN,
  OUT
}
